import Reflux from 'reflux';

import actions from '../actions';
import stateStore from './accessory-state-store';

export default Reflux.createStore({
	listenables: actions,

	init() {
		this.listenTo(stateStore, this.onStateChange);
		this.state = {
			itemListPage: -1,
			items: [],
			sheet: null,
			count: null
		};
	},

	onStateChange(state) {
		this.state.itemListPage = state.itemListPage;
		if (this.state.itemListPage === -1) {
			this.state.items = [];
		}
		this.output();
	},

	onLoadAccessoryCountCompleted(data) {
		const state = data.body;
		if (data.autoSheet && state.count === 1 && this.state.count !== state.count) {
			actions.loadAccessorySheet();
		}
		this.state.count = state.count;
		this.output();
	},

	onLoadAccessoriesCompleted(data) {
		const items = data.body;
		if (this.state.itemListPage <= 0) {
			this.state.items = items;
		} else {
			this.state.items = this.state.items.concat(items);
		}

		this.output();
	},

	onLoadAccessoryCompleted(data) {
		const items = data.body;
		this.state.sheet = items[0];

		this.output();
	},

	onCloseSheet(isAuto) {
		this.state.sheet = null;
		this.state.itemListPage = -1;
		this.output();

		if (isAuto) {
			actions.resetAccessoryListPage();
		}
	},

	getState() {
		return this.state;
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
